// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1XDWo","row":"style_row__3osy4","rowAvg":"style_rowAvg__2lxLf","select":"style_select__sxThr","wrapperAvg":"style_wrapperAvg__1LUUg"};